import { Helmet } from "react-helmet";

export const Politicas = () => {

    return (
        <div className="container">

            <Helmet>
                <title>Política de Privacidad | Travel Friends Agencia de Viajes</title>
                <meta name="description" content="En Travel Friends protegemos tu información. Consulta nuestra política de privacidad y conoce cómo manejamos tus datos personales de forma segura y transparente.">
                </meta>
                </Helmet>

                <h1>Políticas de Privacidad</h1>
                <p>En <strong>Travel Friends</strong>, la privacidad y seguridad de nuestros usuarios son una prioridad. En este documento, te explicamos cómo recopilamos, utilizamos y protegemos tu información personal.</p>

                <h2>1. Información que recopilamos</h2>
                <p>Podemos recopilar los siguientes tipos de información:</p>
                <ul>
                    <li>Datos de contacto como nombre, correo electrónico, y número de teléfono.</li>
                    <li>Información de pago, como número de tarjeta de crédito (procesada a través de plataformas seguras).</li>
                    <li>Detalles del viaje, como fechas, destinos y preferencias.</li>
                    <li>Datos de navegación, como dirección IP, tipo de dispositivo y comportamiento en el sitio web.</li>
                </ul>

                <h2>2. Uso de la información</h2>
                <p>La información recopilada se utiliza para:</p>
                <ul>
                    <li>Procesar reservas y cotizaciones de viajes.</li>
                    <li>Enviar comunicaciones relacionadas con tu viaje.</li>
                    <li>Personalizar tu experiencia en el sitio web.</li>
                    <li>Mejorar nuestros servicios y realizar análisis internos.</li>
                </ul>

                <h2>3. Compartir información</h2>
                <p>No compartimos tu información personal con terceros, excepto en los siguientes casos:</p>
                <ul>
                    <li>Con proveedores de servicios necesarios para procesar tu reserva (por ejemplo, aerolíneas y hoteles).</li>
                    <li>Cuando sea requerido por ley o para cumplir con procedimientos legales.</li>
                    <li>Para proteger nuestros derechos, propiedad o seguridad, o los de nuestros usuarios.</li>
                </ul>

                <h2>4. Seguridad</h2>
                <p>Implementamos medidas de seguridad técnicas y administrativas para proteger tu información personal. Sin embargo, ninguna transmisión de datos en línea es 100% segura.</p>

                <h2>5. Cookies</h2>
                <p>Utilizamos cookies para mejorar tu experiencia en el sitio web. Puedes configurar tu navegador para rechazar cookies, aunque esto podría afectar algunas funcionalidades del sitio.</p>

                <h2>6. Tus derechos</h2>
                <p>Tienes derecho a:</p>
                <ul>
                    <li>Acceder, corregir o eliminar tu información personal.</li>
                    <li>Optar por no recibir comunicaciones promocionales.</li>
                    <li>Solicitar detalles sobre el tratamiento de tus datos personales.</li>
                </ul>
                <p>Para ejercer tus derechos, contáctanos en <a href="mailto:contacto@travelfriends.com.mx">contacto@travelfriends.com.mx</a>.</p>

                <h2>7. Cambios en las políticas</h2>
                <p>Nos reservamos el derecho de actualizar estas políticas en cualquier momento. Notificaremos los cambios en esta página.</p>

                <h2>8. Contacto</h2>
                <p>Si tienes preguntas o inquietudes sobre nuestras políticas de privacidad, contáctanos:</p>
                <p><strong>Travel Friends</strong></p>
                <p>Email: <a href="mailto:contacto@travelfriends.com.mx">contacto@travelfriends.com.mx</a></p>
                <p>Teléfono: +52 55 1212 0049</p>

        </div>
    )
}
export default Politicas;